import React, { useEffect, useReducer } from 'react';
import { Column, Link, Row, Grid } from '@carbon/react';

import { Page } from '../../components/Page';

import {
  Panel,
  PanelHeader,
  PanelLabel,
  PanelFooter,
  PanelLink,
  PanelStatistics,
  PanelStatistic,
  PanelValue,
  PanelStatisticsFooter,
} from '../../components/Panel';

import { ChartNetwork, UserMultiple } from '@carbon/react/icons';
import { statisticsService } from '../../redux/services/statistics.service';
//import '../_overrides.scss';

const initialState = {
  elements_count: 0,
  streams_count: 0,
  locations_count: 0,
  users_count: 0,
  devices_count: 0,
  tags_count: 0,
  loading: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'request_statistics':
      return initialState;

    case 'resolve_statistics':
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    default:
      throw new Error();
  }
};

export const Overview = ({ handleNavChange, sideNav }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({ type: 'request_statistics' });
    statisticsService
      .get_statistics()
      .then((data) =>
        dispatch({ type: 'resolve_statistics', data: data.data })
      );
  }, []);

  return (
    <Page pageTitle="Administration">
      <Row>
        <Column md={3}>
          <Panel halfSize>
            <PanelHeader header>Datenbank Statistik</PanelHeader>

            <PanelStatistics>
              <PanelStatistic>
                <PanelValue>
                  {state.elements_count}
                </PanelValue>
                <PanelStatisticsFooter>Elemente</PanelStatisticsFooter>
              </PanelStatistic>
              <PanelStatistic>
                <PanelValue>
                  {state.streams_count}
                </PanelValue>
                <PanelStatisticsFooter>Streams</PanelStatisticsFooter>
              </PanelStatistic>
              <PanelStatistic>
                <PanelValue>
                  {state.locations_count}
                </PanelValue>
                <PanelStatisticsFooter>Standorte</PanelStatisticsFooter>
              </PanelStatistic>
              <PanelStatistic>
                <PanelValue>
                  {state.users_count}
                </PanelValue>
                <PanelStatisticsFooter>Benutzer</PanelStatisticsFooter>
              </PanelStatistic>
              <PanelStatistic>
                <PanelValue>
                  {state.devices_count}
                </PanelValue>
                <PanelStatisticsFooter>Geräte</PanelStatisticsFooter>
              </PanelStatistic>
              <PanelStatistic>
                <PanelValue>
                  {state.tags_count}
                </PanelValue>
                <PanelStatisticsFooter>Tags</PanelStatisticsFooter>
              </PanelStatistic>
            </PanelStatistics>

          </Panel>
        </Column>

        <Column md={5}>
          <Row>
            <Column md={4}>
              <Panel halfSize>
                <PanelHeader header>
                  Benutzer
                </PanelHeader>
                <UserMultiple size={32} width={64} height={64} />
                <PanelLabel>Übersicht aller Benutzer</PanelLabel>
                <PanelFooter>
                  <PanelLink onClick={() => handleNavChange('USERS')}>
                    BENUTZER VERWALTEN &gt;
                  </PanelLink>
                </PanelFooter>
              </Panel>
            </Column>
            <Column md={4}>
              <Panel halfSize>
                <PanelHeader header>
                  Features
                </PanelHeader>
                <ChartNetwork size={32} width={64} height={64} />
                <PanelLabel>
                  Verändere die Einstellungen der Features
                </PanelLabel>
                <PanelFooter>
                  <PanelLink onClick={() => handleNavChange('FEATURES')}>
                    FEATURES BEARBEITEN &gt;
                  </PanelLink>
                </PanelFooter>
              </Panel>
            </Column>
          </Row>

          <Row>
            <Column md={4}>
              <Panel>
                <PanelHeader centered>Wichtige Links</PanelHeader>
                <PanelLabel centered>Liste der Wichtigsten Links</PanelLabel>
                <Link
                  href="https://mender.micast.de"
                  title="Mender - Systemverwaltung"
                  target="_blank">
                  Mender - Systemverwaltung
                </Link>
                <PanelFooter></PanelFooter>
              </Panel>
            </Column>
          </Row>
        </Column>
      </Row>
    </Page>
  );
};
